__turbopack_context__.v({
  "ctas": "page-module__E0kJGG__ctas",
  "intro": "page-module__E0kJGG__intro",
  "logo": "page-module__E0kJGG__logo",
  "main": "page-module__E0kJGG__main",
  "page": "page-module__E0kJGG__page",
  "primary": "page-module__E0kJGG__primary",
  "secondary": "page-module__E0kJGG__secondary",
});
